<template>
    <Teleport to="body">
        <div class="modal" tabindex="-1" id="employeeEditProfileModal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div v-if="error" class="row w-100 mb-2 ml-2 pr-2" @click="error = null">
                        <div class="col bg-danger text-white p-2 text-center">
                            {{ error }}<i class="fas fa-close float-end"></i>
                        </div>
                    </div>
                    <div class="modal-header">
                        <div class="row w-100">
                            <div class="col-12">
                                <h4>{{ $trans.get("__JSON__." + settingtype + " Profiles assigned") }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" id="mediumBody">
                        <div class="row">
                            <div class="col-12">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{{ $trans.get("__JSON__.valid from") }}</th>
                                            <th>{{ $trans.get("__JSON__.Profile name") }}</th>
                                            <th>{{ $trans.get("__JSON__.created at") }}</th>
                                            <th>{{ $trans.get("__JSON__.created by") }}</th>
                                            <th>{{ $trans.get("__JSON__.Actions") }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(settingprofile, index) in settingprofiles">
                                            <td>
                                                {{ settingprofile.pivot.start_at }}
                                            </td>
                                            <td>
                                                {{ settingprofile.name }}
                                            </td>
                                            <td> 
                                                {{ to_luxon_ISOdate(settingprofile.pivot.created_at) }} 
                                            </td>
                                            <td>
                                                {{ settingprofile.pivot.created_by }}
                                            </td>
                                            <td v-if="settingtype === 'VacationProfile'">
                                                <button :id="'delete_vacation_profile_' + index" type="button" @click="deleteSettingProfile(settingprofile)"
                                                    class="btn text-danger ">
                                                    <span class="material-symbols-outlined">
                                                        delete
                                                    </span>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="5">
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <button type="button" @click="showAddingFields"
                                                        class="btn btn-primary d-flex justify-content-center align-items-center float-end"
                                                        style="height:15px; width: 15px;">
                                                        <span class="material-symbols-outlined">
                                                            add
                                                        </span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-if="adding"
                        class="modal-footer d-flex border border-dark-subtle bg-light-subtle justify-content-center">
                        <div class="row w-100 d-flex justify-content-center align-items-start">
                            <div class="col-4">
                                <div class="input-group" id="startAt">
                                    <span class="input-group-text">
                                        <span class="material-symbols-outlined">
                                            calendar_month
                                        </span>
                                    </span>
                                    <input v-model="startAt" type="date" class="form-control" id="startdate"
                                        name="start_at[]" autocomplete="off" />
                                </div>
                                <label for="startAt">{{ $trans.get("__JSON__.valid from") }}</label>
                            </div>
                            <div class="col-5">
                                <select class="form-control" v-model="selectedSettingProfile" id="selectSettingProfile">
                                    <option :value="null" selected disabled>
                                        {{ $trans.get("__JSON__.Choose " + settingtype + " profile") }}
                                    </option>
                                    <option v-for="item in allsettingprofiles" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                                <label for="selectSettingProfile">{{ $trans.get("__JSON__." + settingtype + " profile")
                                    }}
                                </label>
                            </div>
                        </div>
                        <div class="row w-100 d-flex justify-content-end">
                            <div class="col-2 d-flex justify-content-end">
                                <button class="btn btn-primary mr-2" @click.prevent="attachAction">
                                    {{ $trans.get('__JSON__.Save') }}
                                </button>
                                <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                    @click.prevent="closeModal">
                                    {{ $trans.get("__JSON__.Cancel") }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="modal-footer">
                            <button class="btn btn-secondary" data-bs-dismiss="modal">{{ $trans.get('__JSON__.close') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>


<script>
import employeeFlextimeProfilesHandling from '../composables/employeeFlextimeProfiles';
import employeeSettingProfilesHandling from '../composables/employeeSettingProfiles';

import employeeBonusProfilesHandler from '../composables/employeeBonusProfiles';
import worktimesHandler from '../composables/worktimes';
import flextimeProfilesHandler from '../composables/flextimeprofiles';
import getCostcentres from '../composables/getCostcentres';
import getVacationProfiles from '../composables/vacationProfiles';

import { DateTime } from 'luxon';

export default {
    name: "EmployeeSettingProfiles",
    setup() {
        const { employeeFlextimeProfiles_error, attachFlextimeProfile } = employeeFlextimeProfilesHandling();
        const { employeeSettingProfiles_error, attachSettingProfile, employeeSettings, loadEmployeeSettings } = employeeSettingProfilesHandling();
        const { allEmployeeBonusProfiles, employeeBonusProfiles_error, loadAllEmployeeBonusProfiles } = employeeBonusProfilesHandler();
        const { allWorktimes, worktimes_error, loadAllWorktimes } = worktimesHandler();
        const { allFlextimeProfiles, flextimeProfiles_error, loadAllFlextimeProfiles } = flextimeProfilesHandler();
        const { costcentres, costcentres_error, loadCostcentres } = getCostcentres();
        const { vacationProfiles, vacationProfiles_error, loadVacationProfiles } = getVacationProfiles();

        return {
            employeeFlextimeProfiles_error, attachFlextimeProfile,
            employeeSettingProfiles_error, attachSettingProfile,
            allEmployeeBonusProfiles, employeeBonusProfiles_error, loadAllEmployeeBonusProfiles,
            employeeSettings, loadEmployeeSettings,
            allWorktimes, worktimes_error, loadAllWorktimes,
            allFlextimeProfiles, flextimeProfiles_error, loadAllFlextimeProfiles,
            costcentres, costcentres_error, loadCostcentres,
            vacationProfiles, vacationProfiles_error, loadVacationProfiles 
        };
    },
    created() {
        this.emitter.on('edit-setting', (evt) => {
            console.log('Edit setting event', evt);
            this.settingtype = evt.setting;
            this.loadProfiles();
        });

    },
    props: {
        employee_id: Number,
    },
    data() {
        return {
            error: null,
            adding: false,
            selectedSettingProfile: null,
            startAt: null,
            settingtype: null,
            settingprofiles: null,
            allsettingprofiles: null
        };
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        async loadProfiles() {

            if (this.settingtype == 'EmployeeBonusProfile') {
                const employerId = $('#employer_id').val();
                await this.loadAllEmployeeBonusProfiles(employerId);
                this.allsettingprofiles = this.allEmployeeBonusProfiles;
                await this.loadEmployeeSettings(this.employee_id, this.settingtype);
                this.settingprofiles = this.employeeSettings;

                $('#employeeEditProfileModal').modal('show');
            }

            if (this.settingtype == 'Worktime') {
                await this.loadAllWorktimes();
                this.allsettingprofiles = this.allWorktimes;
                await this.loadEmployeeSettings(this.employee_id, this.settingtype);
                this.settingprofiles = this.employeeSettings;

                $('#employeeEditProfileModal').modal('show');
            }

            if (this.settingtype == 'FlextimeProfile') {
                await this.loadAllFlextimeProfiles();
                this.allsettingprofiles = this.allFlextimeProfiles;
                await this.loadEmployeeSettings(this.employee_id, this.settingtype);
                this.settingprofiles = this.employeeSettings;

                $('#employeeEditProfileModal').modal('show');
            }

            if (this.settingtype == 'Costcentre') {
                await this.loadCostcentres();
                this.allsettingprofiles = this.costcentres;
                this.allsettingprofiles.forEach(costcentre => {
                    costcentre.name = costcentre.costcentre + "  " + costcentre.name;
                });
                await this.loadEmployeeSettings(this.employee_id, this.settingtype);
                this.settingprofiles = this.employeeSettings;

                console.log(this.allsettingprofiles);
                $('#employeeEditProfileModal').modal('show');
            }

            if (this.settingtype == 'VacationProfile') {
                await this.loadVacationProfiles();
                this.allsettingprofiles = this.vacationProfiles;
                await this.loadEmployeeSettings(this.employee_id, this.settingtype);
                this.settingprofiles = this.employeeSettings;

                $('#employeeEditProfileModal').modal('show');
            }

        },
        showAddingFields() {
            this.adding = true;
        },
        async attachFlextimeProfile() {
            this.error = null;
            let data = await this.attachFlextimeProfile(this.employee_id, this.selectedSettingProfile, this.startAt);
            this.error = data.message;

            if (data.status == 'ok') {
                this.adding = false;
                this.selectedFlextimeProfile = null,
                    this.startAt = null,
                    $('#employeeflextimeprofilesmodal').modal('hide');
                window.location.reload();
            }
        },
        async attachAction() {
            this.error = null;
            let isOK = 'notOK';
            let newCostcentre = null;
            if (this.settingtype == 'FlextimeProfile') {
                let data = await this.attachFlextimeProfile(this.employee_id, this.selectedSettingProfile, this.startAt);
                this.error = data.message;
                isOK = data.status;
            }

            if (this.settingtype == 'Costcentre') {
                console.log('click add costcentre');
                newCostcentre = this.allsettingprofiles.find((settingprofile) => settingprofile.id == this.selectedSettingProfile).costcentre;
                let data = await this.attachSettingProfile(this.employee_id, newCostcentre, this.settingtype, this.startAt);
                this.error = data.message;
                isOK = data.status;
            }

            if (this.settingtype != 'FlextimeProfile' && this.settingtype != 'Costcentre') {
                let data = await this.attachSettingProfile(this.employee_id, this.selectedSettingProfile, this.settingtype, this.startAt);
                this.error = data.message;
                isOK = data.status;
            }

            if (isOK == 'ok') {
                this.adding = false;
                this.selectedFlextimeProfile = null,
                    this.startAt = null,
                    $('#employeeflextimeprofilesmodal').modal('hide');
                window.location.reload();
            }
        },
        deleteSettingProfile(selectedProfile) {
            axios
                .delete('/api/employees/' + this.employee_id + '/settings/' + selectedProfile.id + '?settingtype=' + this.settingtype)
                .then(response => {
                    if(response.status == 200) {
                        this.editing = false;
                        this.selectedSettingProfile = null,
                        this.startAt = null

                        this.settingprofiles = this.settingprofiles.filter(profile => profile.id !== selectedProfile.id);
                        let currentProfile = this.settingprofiles
                            .filter(profile => DateTime.fromISO(profile.pivot.start_at) <= DateTime.now())
                            .sort((a, b) => {
                                return new Date(b.pivot.start_at) - new Date(a.pivot.start_at);
                            })[0];
                            
                        if (currentProfile && currentProfile.id) {
                            $('#vacation_profile_id').val(currentProfile.id);
                        }
                    }
                })
                .catch(error => {
                    console.error('Error deleting setting profile:', error);
                    this.error = this.$trans.get("__JSON__.An error occurred while updating the profile.");
                });
            return;
        },
        closeModal() {
            this.adding = false;
            this.selectedSettingProfile = null,
                this.startAt = null,
                this.employeeFlextimeProfiles_error = null;
            this.employeeSettingProfiles_error = null;
            this.error = null;
            $('#employeeflextimeprofilesmodal').modal('hide');
        },
        to_luxon_ISOdate(date) {
            let formattedDate = null;
            if(typeof date == 'object') {
                formattedDate = DateTime.fromJSDate(date).toISODate();
            }
            if(typeof date == 'string') {
                formattedDate = DateTime.fromISO(date).toISODate();
            }
            return formattedDate;
        },
    },
};
</script>